module.exports = __webpack_public_path__ + "static/media/3.4ff259a8.png";